import { SHStack, SHTypography } from "@components/design-systems";
import { CheckSVG, CrossSVG } from "@components/svgs";
import { MAAnalysisDataDTO } from "@models/managed-accounts/entities/step/fee";
import { ManagedAccountFieldTypeValue } from "@models/managed-accounts/enums/fieldTypeValue";
import { memo } from "react";

interface YesNoTextCellProps {
  analysisData?: MAAnalysisDataDTO;
}

export const YesNoTextCell = memo(({ analysisData }: YesNoTextCellProps) => {
  const { value } = analysisData || {};

  const RenderComponent = () => {
    const Component = RenderValueMap[value as ManagedAccountFieldTypeValue];

    if (Component) return Component;

    return (
      <SHTypography variant="body3" colorVariant="third" lineHeight="120%">
        {analysisData?.value}
      </SHTypography>
    );
  };

  return <RenderComponent />;
});

const RenderValueMap: Partial<
  Record<ManagedAccountFieldTypeValue, JSX.Element>
> = {
  [ManagedAccountFieldTypeValue.True]: (
    <SHStack direction="row" spacing={0.5}>
      <CheckSVG />
      <SHTypography variant="body3" colorVariant="third" lineHeight="120%">
        Net
      </SHTypography>
    </SHStack>
  ),
  [ManagedAccountFieldTypeValue.False]: (
    <SHStack direction="row" spacing={0.5}>
      <CrossSVG />
      <SHTypography variant="body3" colorVariant="third" lineHeight="120%">
        Gross
      </SHTypography>
    </SHStack>
  ),
  [ManagedAccountFieldTypeValue.Multiple]: (
    <SHTypography variant="body3" colorVariant="third" lineHeight="120%">
      Multiple
    </SHTypography>
  ),
};
